<template>
	<v-form @submit.prevent ref="form" v-model="valid">
		{{ valid }}
		<functionality-form :doc="doc" />
		<v-btn class="mt-5 amber black--text" @click="onSubmit">Submit</v-btn>
		<v-btn class="mt-5 amber black--text ml-2" @click="onClose">Close</v-btn>
	</v-form>
</template>

<script>
// @ is an alias to /src
import FunctionalityForm from './FunctionalityForm';
import { mapState } from 'vuex';
const fb = require('@/firebaseConfig.js');

export default {
	name: 'UserServiceFormAdd',
	components: {
		FunctionalityForm,
	},
	data() {
		return {
			valid: true,
			doc: {},
		};
	},
	computed: {
		...mapState([
			'userProfile',
			'currentUser',
			'currentProject',
			'currentProjectModel',
		]),
	},
	methods: {
		onSubmit(evt) {
			evt.preventDefault();
			this.validate();
			if (this.valid) {
				let ref = fb.functionalityCollection.doc();
				ref
					.set({
						createdOn: new Date(),
						id: ref.id,
						uid: this.currentUser.uid,
						title: this.populateField(this.doc.title),
						description: this.populateField(this.doc.description),
						value: this.populateField(this.doc.value),
						note: this.populateField(this.doc.note),
						project: this.currentProjectModel.id,
					})
					.then(() => {
						this.$emit('complete');
					})
					.catch((error) => {
						alert('Error adding document: ', error);
					});
			}
		},
		onClose() {
			this.$emit('close');
		},
		populateField(field) {
			return field ? field : null;
		},
		validate() {
			this.$refs.form.validate();
		},
	},
};
</script>
